import Slider from 'nouislider';
const DEFAULTS = {
}

export default class CustomRange {

  constructor (el, options) {
    this.options = options;
    // Assuming contact form 7, and follow the same structure
    this.$el = $(el)
    this.init();
  }

  /**
   * Register this component as global jquery plugin
   */
  static jqueryPlugin () {
    $.fn.customRange = function (option) {
        var args = Array.prototype.slice.call(arguments, 1)
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('trueper.custom-range')
            var options = $.extend({}, DEFAULTS, $this.data(), typeof option == 'object' && option)
            if (!data) $this.data('trueper.custom-range', (data = new CustomRange(this, options)))
            else if (typeof option == 'string') data[option].apply(data, args)
        })
    }
    $.fn.customRange.Constructor = CustomRange
    $('.custom-range').customRange();
  }

  init () {
    this.$wrapper = $('<div class="custom-slider-ui"></div>')
    this.$el.before(this.$wrapper)
    this.$el.wrap('<div class="px-2 w-2/12"></div>')
    this.wrapper = this.$wrapper.get(0)
    this.$wrapper.wrap('<div class="px-2 w-10/12"></div>')

    Slider.create(this.wrapper, {
      start: [2000],
      connect: 'lower',
      range: {
          'min': 2000,
          'max': 30000,
      },
      // 'to' the formatted value. Receives a number.
      to: function (value) {
        return '$ ' + value + ',-';
      },
      // 'from' the formatted value.
      // Receives a string, should return a number.
      from: function (value) {
          return Number(value
            .replace(',-', '')
            .replace('$ ', ''));
      },
    });
    this.wrapper.noUiSlider.on('update', (values) => {
      this.$el.val(`$ ${values[0]}`)
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/custom-range.js